import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export const ComplaintsForm = ({ onAdd, onClose }) => {
    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                complaints: Yup.string().required(' '),
                duration: Yup.string().required(' '),
            })
        ),
        mode: 'all'
    });
    const { handleSubmit, reset } = methods;

    const formSubmit = (formValue) => {
        onAdd(formValue);
        reset();
    };
    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                <Typography sx={{ flex: 0.4 }}>Complaint</Typography>
                <TextField
                    sx={{
                        flex: 1,
                        '& .MuiInputBase-root': {
                            height: '200px'
                        }
                    }}
                    placeholder="Add Complaints"
                    name="complaints"
                    multiline
                    minRows={12}
                />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center" sx={{ mb: 1 }}>
                <Typography sx={{ flex: 0.4 }}>Duration</Typography>
                <TextField
                    sx={{ flex: 1 }}
                    name="duration"
                    placeholder="Duration"
                />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                    Add
                </Button>
                <Button color="error" onClick={onClose}>
                    Close
                </Button>
            </Stack>
        </FormProvider>
    );
};
